import { useEffect } from "react";
import MyEventListingSection from "../../components/Events/MyEventListingSection";
import Page from "../../components/Page";
import EventListSection from "../../components/NewDesign/Event/EventListSection";


const MyEventsPage = () => {

  useEffect(()=>{
    window.scrollTo(0,0)
},[])

  return (
    <Page>
    <EventListSection />
    </Page>

  )


}

export default MyEventsPage;